var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass:
        "max-width pa-0 align-items-end align-end white text-center pb-2",
    },
    [
      _c("div", { staticClass: "d-flex justify-end flex-column" }, [
        _c(
          "div",
          {
            staticClass: "text-h4 font-weight-medium pb-1",
            class: _vm.isNow ? "" : "text--secondary",
          },
          [_vm._v(" " + _vm._s(_vm.day) + " ")]
        ),
        _c(
          "div",
          {
            staticClass: "text-caption-xs",
            class: _vm.isNow ? "" : "text--secondary",
          },
          [_vm._v(" " + _vm._s(_vm.$t(_vm.week)) + " ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }